import { render } from "./SessionManager.vue?vue&type=template&id=2d163936"
import script from "./SessionManager.vue?vue&type=script&lang=js"
export * from "./SessionManager.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Active\\Workspace\\www\\ETDotCom_v2\\EndlessTheoryDotCom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__